import { render } from "./AmazonLivenessCapture.vue?vue&type=template&id=34e25cd1&scoped=true"
import script from "./AmazonLivenessCapture.vue?vue&type=script&lang=js"
export * from "./AmazonLivenessCapture.vue?vue&type=script&lang=js"

import "./AmazonLivenessCapture.vue?vue&type=style&index=0&id=34e25cd1&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\payroll-system\\dashboards\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e25cd1"]])

export default __exports__